<template style="height: 100%;">
  <div class="Already_test">
    <div class="search_cnt">
      <el-input  v-model="content"  :placeholder="$t('original.languages110')"  class="text-search"  style="width: 300px !important;"  maxlength="15"  :clearable="true" @clear = "removeall"></el-input>
      <el-button @click="loading(1)" type="primary" style="margin-left: 10px;">
        {{$t('original.screening')}}
      </el-button>
    </div>

    <el-table v-loading="loadings" :row-key="(row) => {return row.PaperResultID}" :data="tableData" style="width: 100%; margin-top: 10px;" :default-sort="{ prop: 'date', order: 'descending'}">

      <el-table-column :label="$t('original.The_serial_number')" width="60px" align="center">
        <template slot-scope="scope" center>
          {{ (pageIndex - 1) * 10 + scope.$index + 1 }}
        </template>
      </el-table-column>

      <el-table-column :label="$t('original.account')">
        <template slot-scope="scope">
          <span>{{ scope.row.UserID }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('original.name')">
        <template slot-scope="scope">
          <span>{{ scope.row.RealName }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('original.languages591')">
        <template slot-scope="scope">
          <span>
            {{ scope.row.PubName ? scope.row.PubName : $t('original.languages592') }}
          </span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('original.Name_of_scale')" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.PaperName }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('original.languages562')" width="200" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.IsSubmit == $t('original.languages593')" slot="reference" class="name-wrapper">
            <span style="margin-left: 10px;">{{ scope.row.StartTime }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column :label="$t('original.languages152')">
        <template slot-scope="scope">
          <span v-if="scope.row.IsSubmit == $t('original.languages593')">{{ scope.row.SETime }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('original.languages147')">
        <template slot-scope="scope">
          <span>{{ scope.row.IsSubmit }}</span>
        </template>
      </el-table-column>

      <el-table-column fixed="right" :label="$t('original.languages49')" width="140">
        <template slot-scope="scope">

          <el-button v-if="scope.row.IsSubmit == $t('original.languages593')"  @click="handleClick(scope.row)" type="text" size="small">
            {{$t('original.languages73')}}
          </el-button>

          <el-button v-else disabled type="text" size="small">
            {{$t('original.languages73')}}
          </el-button>
          
        </template>
        
      </el-table-column>

    </el-table>
    <div class="block">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1" :page-size="10" layout="total, prev, pager, next" :total="Counts"></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageIndex: 1,
      loadings: false,
      content: '',
      tableData: [],
      Counts: 1,
      currentPage1: 1,
      formInline: {
        Name: '',
        Student: '',
        ScaleName: '',
        TestTime: '',
        PublishID: '',
        ObjectS: '',
        StudyTime: '',
        Warning: '',
      },
    }
  },
  methods: {
    handleEdit(index, row) {
      this.$router.push({
        path:'/measurement/PaperTest',
        query:{PaperID:row.PaperID},
      })
    },
    handleClick(a, b) {
      let routeData = this.$router.resolve({
        path: '/visitors/ReportShow',
        query: { PaperResultID: a.PaperResultID },
      })
      window.open(routeData.href, '_blank');
    },
    handleSizeChange(val) {
    },
    handleCurrentChange(val) {
      this.loading(val);
    },
    loading(num) {
      this.pageIndex = num;
      this.loadings = true;
      this.$Http_Post('ScaleIssue/GetLfzMeasuredText',{ content: this.content, pageSize: '10', pageIndex: num }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.loadings = false;
          this.tableData = res.Data;
          this.Counts = Number(res.Counts);
        } else {
          this.loadings = false;
        }
      })
    },
    resetForm() {
      this.content = '';
      this.loading(1);
    },
    removeall(){
      this.loading(1);
    },
  },
  mounted() {
    this.loading(1);
  },
}
</script>
<style>
.Already_test {
  border: 1px solid #e7e7e7;
  padding: 16px;
  position: relative;
  background-color: #fff;
  min-height: 750px;
}
.Already_test h2 {
  font-size: 20px;
  padding-bottom: 20px;
}
.Already_test .block {
  float: right;
  margin-top: 0px;
}
.Already_test .search_cnt {
  text-align: center;
}
.search_cnt .s-cnt {
  width: 460px;
}
.Already_test .el-input {
  width: 260px !important;
}
</style>
